import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { invalidateMany } from './queryUtils';
import {
  getFactoryRepoPolicies,
  upsertFactoryRepoPolicy,
  type FactoryRepoPolicyInput,
} from '../services/api/factoryRepoPolicies';

/**
 * MKS-471 (Phase 128 / Plan 128-03) — TanStack Query hooks for the Factory repository policy card.
 * Phase 130 (Plan 130-15): the policy is read-only (factory.yml at main); the only write is the
 * Paperclip project name. Server-confirm only (no optimistic update): the backend validates every
 * write and can refuse it with a 400 the card must show, so a stale optimistic UI would hide that.
 */
export const FACTORY_REPO_POLICIES_KEY = ['factory-repo-policies'] as const;

export function useFactoryRepoPolicies() {
  return useQuery({
    queryKey: FACTORY_REPO_POLICIES_KEY,
    queryFn: getFactoryRepoPolicies,
  });
}

export function useUpsertFactoryRepoPolicy() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: FactoryRepoPolicyInput) => upsertFactoryRepoPolicy(input),
    onSuccess: () => {
      invalidateMany(queryClient, [FACTORY_REPO_POLICIES_KEY]);
    },
  });
}
